import { render } from "./PerformanceCharts.vue?vue&type=template&id=c0a01af6&scoped=true"
import script from "./PerformanceCharts.vue?vue&type=script&lang=js"
export * from "./PerformanceCharts.vue?vue&type=script&lang=js"

import "./PerformanceCharts.vue?vue&type=style&index=0&id=c0a01af6&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0a01af6"]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading});
